<template>
    <vue-drag-resize class="point" :isActive="true" :isDraggable="true" :isResizable="isResizable" :w="w"
                     @resizestop="resizeStop"
                     :h="h" :x="x" :y="y" :minw="1" :minh="1" v-on:resizing="resize" v-on:dragging="resize"
                     @clicked="myClick">
        <canvas v-if="drawData!=null" :id="'pc'+id" :width="w" :height="h"></canvas>
    </vue-drag-resize>

</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex';
import VueDragResize from 'vue-drag-resize';

export default {
    name: 'point',
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
        }),
    },
    data() {
        return {
            selectElement: '', myStyle: null, squareStyle: {width: '15px', height: '15px', border: '1px solid red'},
            theDialogVisible: true, myData: null,
            pw: 0, ph: 0, px: 0, py: 0,
            percent: {
                "P2": [[0.4341085271317829416663750, 0.748062015503875991667], [0.748062015503875991667, 1]], 
                // "P2": [[0.2, 0.6], [0.6, 1]], 
                // "PD2": [[0.37184693, 0.689799434], [0.689799434, 1]],
                "PD2": [[0.433821418333, 0.73459296629632963], [0.70141708708336667, 1]],
                "P3": [[0.353982300884955750000, 0.5693215339233038333333333],
                 [0.5693215339233038333333333, 0.7846607669616519166666666], 
                 [0.7846607669616519166666666, 1]],
                // 0.8
                // "P4": [[0.2857142857142857000000, 0.4595238095238095133333333], [0.4595238095238095133333333,0.6333333333333333266666666], [0.6333333333333333266666666, 0.8071428571428571399999999], [0.8071428571428571399999999, 1]],
                // 0.75
                "P4": [[0.2857142857142857000000, 0.46428571428571427500000000],
                [0.46428571428571427500000000,0.64285714285714285000000000], 
                [0.64285714285714285000000000, 0.82142857142857142500000000], 
                [0.82142857142857142500000000, 1]],
                
                "P5": [[0.2395209580838323500000, 0.39161676646706588000000000], 
                [0.39161676646706588000000000, 0.54371257485029941000000000],
                 [0.54371257485029941000000000, 0.69580838323353294000000000],
                  [0.69580838323353294000000000, 0.84790419161676647000000000], 
                  [0.84790419161676647000000000 , 1]],
                  
                "P6": [[0.2061855670103092750000, 0.33848797250859106250000000], 
                [0.33848797250859106250000000, 0.47079037800687285000000000],
                 [0.47079037800687285000000000, 0.60309278350515463750000000], 
                 [0.60309278350515463750000000, 0.73539518900343642500000000], 
                 [0.73539518900343642500000000,0.86769759450171821250000000], 
                 [0.86769759450171821250000000, 1]],


                "P7": [[0.1809954751131221875000, 0.29799612152553330357142857],
                 [0.29799612152553330357142857, 0.41499676793794441964285714],
                  [0.41499676793794441964285714,0.53199741435035553571428571],
                   [0.53199741435035553571428571, 0.64899806076276665178571428],
                    [0.64899806076276665178571428,  0.76599870717517776785714285],
                     [0.76599870717517776785714285,  0.88299935358758888392857142],
                      [0.88299935358758888392857142, 1]],


                "P8": [[0.1612903225806451625000, 0.26612903225806451718750000],
                 [0.26612903225806451718750000, 0.37096774193548387187500000],
                  [0.37096774193548387187500000,  0.47580645161290322656250000],
                   [0.47580645161290322656250000,  0.58064516129032258125000000],
                    [0.58064516129032258125000000,  0.68548387096774193593750000],
                     [0.68548387096774193593750000,  0.79032258064516129062500000],
                      [0.79032258064516129062500000, 0.89516129032258064531250000],
                       [0.89516129032258064531250000, 1]],


                       
                "P9": [[0.1454545454545454500000,0.24040404040404040000000000],
                 [0.24040404040404040000000000 ,  0.33535353535353535000000000],
                  [0.33535353535353535000000000, 0.43030303030303030000000000],
                   [0.43030303030303030000000000,  0.52525252525252525000000000],
                    [0.52525252525252525000000000,  0.62020202020202020000000000],
                     [0.62020202020202020000000000, 0.71515151515151515000000000],
                      [0.71515151515151515000000000,  0.81010101010101010000000000],
                       [0.81010101010101010000000000,  0.90505050505050505000000000],
                        [0.90505050505050505000000000, 1]],


                "P10": [[0.1324503311258278125000,  0.21920529801324503125000000],
                  [0.21920529801324503125000000, 0.30596026490066225000000000], //B
                  [0.30596026490066225000000000, 0.39271523178807946875000000],
                  [0.39271523178807946875000000,  0.47947019867549668750000000], //D
                  [0.47947019867549668750000000, 0.56622516556291390625000000],
                  [0.56622516556291390625000000,  0.65298013245033112500000000], //F
                  [0.65298013245033112500000000,  0.73973509933774834375000000],

                  [0.73973509933774834375000000,  0.843841059602649006250000000], //H
                  [0.843841059602649006250000000,  0.91324503311258278125000000],
                  [0.91324503311258278125000000, 1]],

                //   [0.73973509933774834375000000,  0.82649006622516556250000000], //H
                //   [0.82649006622516556250000000,  0.91324503311258278125000000],
                //   [0.91324503311258278125000000, 1]],



              "P11": [[0.121580547112462000000, 0.2014368610113290909090909], 
              [0.2014368610113290909090909, 0.2812931749101961818181818],
               [0.2812931749101961818181818, 0.3611494888090632727272727], 
               [0.3611494888090632727272727,0.4410058027079303636363636], 
               [0.4410058027079303636363636, 0.5208621166067974545454545], 
               [0.5208621166067974545454545, 0.6007184305056645454545454 ],
                [0.6007184305056645454545454,  0.6805747444045316363636363], 

                [0.6805747444045316363636363, 0.77640232108317214545454538], 
                [0.77640232108317214545454538,  0.84028737220226581818181810], 
                [0.84028737220226581818181810,  0.916150870406189554545454455], 
                [0.916150870406189554545454455, 1]],

                // [0.6805747444045316363636363, 0.7604310583033987272727272], 
                // [0.7604310583033987272727272,  0.8402873722022658181818181], 
                // [0.8402873722022658181818181,  0.9201436861011329090909090], 
                // [0.9201436861011329090909090, 1]],



              "P12": [[0.112359550561797750000, 0.1863295880149812708333333],  //A
                [0.1863295880149812708333333, 0.2602996254681647916666666], //B
                [0.2602996254681647916666666,  0.3342696629213483124999999],
                [0.3342696629213483124999999,  0.4082397003745318333333332], //D
                [0.4082397003745318333333332,  0.4822097378277153541666665],
                [0.4822097378277153541666665, 0.5561797752808988749999998], //F
                [0.5561797752808988749999998,  0.6301498127340823958333331],

                [0.6301498127340823958333331,  0.71891385767790262083333306], //H
                [0.71891385767790262083333306,  0.77808988764044943749999970],
                [0.77808988764044943749999970,  0.848361423220973782291666335], //J
                [0.848361423220973782291666335,  0.922331460674157303124999635],
                [0.922331460674157303124999635, 1]],

                // [0.6301498127340823958333331,  0.7041198501872659166666664], //H
                // [0.7041198501872659166666664,  0.7780898876404494374999997],
                // [0.7780898876404494374999997,  0.8520599250936329583333330], //J
                // [0.8520599250936329583333330,  0.9260299625468164791666663],
                // [0.9260299625468164791666663, 1]],


                "P13": [[0.104438642297650125000, 0.1733279775055231923076923],  //A
                [0.1733279775055231923076923,  0.2422173127133962596153846], //B
                [0.2422173127133962596153846,  0.3111066479212693269230769],
                [0.3111066479212693269230769, 0.3799959831291423942307692], //D
                [0.3799959831291423942307692,  0.4488853183370154615384615],
                [0.4488853183370154615384615,  0.5177746535448885288461538], //F
                [0.5177746535448885288461538,  0.5866639887527615961538461],

                [0.5866639887527615961538461, 0.66933119100220927692307686], //H
                [0.66933119100220927692307686,  0.72444265916850773076923070],
                [0.72444265916850773076923070,  0.789887527615987144711538385], //J
                [0.789887527615987144711538385, 0.858776862823860212019230685],
                [0.858776862823860212019230685,   0.927666198031733279326922985],
                [0.927666198031733279326922985, 1]],

                // [0.5866639887527615961538461, 0.6555533239606346634615384], //H
                // [0.6555533239606346634615384,  0.7244426591685077307692307],
                // [0.7244426591685077307692307,  0.7933319943763807980769230], //J
                // [0.7933319943763807980769230, 0.8622213295842538653846153],
                // [0.8622213295842538653846153,  0.9311106647921269326923076],
                // [0.9311106647921269326923076, 1]],



                "P14": [[0.0975609756097561000000,  0.16202090592334495000000000],  //A
                [0.16202090592334495000000000, 0.22648083623693380000000000 ], //B
                [0.22648083623693380000000000,  0.29094076655052265000000000],
                [0.29094076655052265000000000,  0.35540069686411150000000000], //D
                [0.35540069686411150000000000, 0.41986062717770035000000000 ],
                [0.41986062717770035000000000,  0.48432055749128920000000000], //F
                [0.48432055749128920000000000,  0.54878048780487805000000000],
                

                [0.54878048780487805000000000,  0.626132404181184670000000000], //H
                [0.626132404181184670000000000,  0.67770034843205575000000000],
                [0.67770034843205575000000000,  0.7389372822299651575000000000], //J
                [0.7389372822299651575000000000,  0.8033972125435540075000000000],
                [0.8033972125435540075000000000,   0.8678571428571428575000000000],
                [0.8678571428571428575000000000,  0.9323170731707317075000000000],
                [0.9323170731707317075000000000, 1]],

                // [0.54878048780487805000000000,  0.61324041811846690000000000], //H
                // [0.61324041811846690000000000,  0.67770034843205575000000000],
                // [0.67770034843205575000000000,  0.74216027874564460000000000], //J
                // [0.74216027874564460000000000,  0.80662020905923345000000000],
                // [0.80662020905923345000000000,  0.87108013937282230000000000],
                // [0.87108013937282230000000000,  0.93554006968641115000000000],
                // [0.93554006968641115000000000, 1]],


                "P15": [[0.0915331807780320375000, 0.15209763539282990166666667],  //A
                [0.15209763539282990166666667,  0.21266209000762776583333334], //B
                [0.21266209000762776583333334,  0.27322654462242563000000001],
                [0.27322654462242563000000001,  0.33379099923722349416666668], //D
                [0.33379099923722349416666668,  0.39435545385202135833333335],
                [0.39435545385202135833333335,  0.45491990846681922250000002], //F
                [0.45491990846681922250000002, 0.51548436308161708666666669 ],
                
                [0.51548436308161708666666669,  0.588161708619374523666666694], //H
                [0.588161708619374523666666694,  0.63661327231121281500000003],
                [0.63661327231121281500000003, 0.691121281464530892750000033 ], //J
                [0.691121281464530892750000033, 0.751685736079328756916666703 ],
                [0.751685736079328756916666703, 0.812250190694126621083333373],
                [0.812250190694126621083333373, 0.872814645308924485250000043],
                [0.872814645308924485250000043, 0.933379099923722349416666713],
                [0.933379099923722349416666713, 1]],

                // [0.51548436308161708666666669,  0.57604881769641495083333336], //H
                // [0.57604881769641495083333336,  0.63661327231121281500000003],
                // [0.63661327231121281500000003, 0.69717772692601067916666670 ], //J
                // [0.69717772692601067916666670,  0.75774218154080854333333337],
                // [0.75774218154080854333333337,  0.81830663615560640750000004],
                // [0.81830663615560640750000004, 0.87887109077040427166666671],
                // [0.87887109077040427166666671, 0.93943554538520213583333338 ],
                // [0.93943554538520213583333338, 1]],
                
            },
        }
    },
    components: {
        VueDragResize
    },
    props: {
        id: String,
        h: {
            type: Number,
            default: 15,
        },
        w: {
            type: Number,
            default: 15,
        },
        x: Number,
        y: Number,
        drawData: {
            type: Object, require: false
        },
        isResizable: Boolean,
    },
    mounted: function () {

    },
    watch: {
        drawData: {
            deep: true, immediate: true,
            handler(n, o) {
                console.log(n)
                if (n) {
                    let that = this;
                    this.pw = this.w; this.ph = this.h; this.myData = n;
                    this.$nextTick(()=>{
                        that.drawTheData();
                    });

                }
            }
        },
    },
    methods: {
        myClick(e) {
            // console.log('point click', e)
            this.$emit('select', this.id);
        },
        resizeStop(newRect) {
            console.log("resizestop", newRect);
            this.drawTheData();
        },
        drawTheData() {
            if(!this.myData || this.myData == null) return;
            var canvas = document.getElementById("pc"+this.id);
            console.log("drawTheData", "pc"+this.id, canvas);
            if (canvas.getContext) {
                let ctx = canvas.getContext('2d');
                ctx.width = this.pw; ctx.height = this.ph;
                ctx.font = 'normal 10px Arial,sans-serif '; ctx.strokeStyle = 'red';
                let myType = this.myData.type, myList = this.myData.list, myPos = this.myData.position;
                let pw = this.pw, ph = this.ph;
                if(myType == "regNo"){
                    // console.log("myData1", myList);
                  let noCount = this.myData.count;
                  console.log("regNo", noCount);
                  let w_g = pw / noCount;
                  let h_g = ph / 10;
                  let g4 = w_g / 4;
                  let h4 = h_g / 4;
                  for (let i = 0; i < noCount; i++) {
                    for (let j=0; j<10; j++){
                      let ix = i * w_g
                      let iy = j * h_g
                      ctx.beginPath();ctx.rect(ix+g4, iy+h4/2, g4*2, h4*2);ctx.stroke();
                    }
                  }
                    // for (let i = 0; i < myList.length; i++) {
                    //     for (let j=0; j<myList[i].length; j++){
                    //         let d = myList[i][j];
                    //         let mcW=d.pcWidth*pw, mcH=d.pcHeight*ph;
                    //         let mcX = d.pcLeft*pw+mcW*0.2, mcY = d.pcTop*ph+mcH*0.2;
                    //         // console.log("myData", d.pcLeft, d.pcTop, mcX, mcY, mcW*0.6, mcH*0.6);
                    //         ctx.beginPath();ctx.rect(mcX, mcY, mcW*0.6, mcH*0.6);ctx.stroke();
                    //     }
                    // }
                }
                if(myType == "Object"){
                  let b_x = 0, b_y = 0;
                  for (let i=0; i<myList.length; i++){
                    let branch = myList[i];
                    let pos = branch.position;
                    let bchWidth = pw * pos.width/myPos.width;
                    let bchHeight = ph * pos.height/myPos.height;
                    let bchX = pw * pos.left/myPos.width;
                    let bchY = ph * pos.top/myPos.height;
                    // console.log("kuai", bchWidth, bchHeight, bchX, bchY);
                    ctx.beginPath();ctx.rect(bchX, bchY, bchWidth, bchHeight);ctx.stroke();
                    
                    let ixList = branch.ixList;
                    let ixX = bchX;
                    let ixY = bchY + bchHeight*2.5/pos.height;
                    let tiH = bchHeight*5/pos.height;
                    let percent = this.percent["P"+branch.chooseCount];
                    
                    for (let j=0; j<ixList.length; j++){
                      let iY = ixY + j*tiH;
                      for (let k=0; k<percent.length; k++){
                        let tiX = bchX+bchWidth*percent[k][0];
                        let tiXEnd = bchX+bchWidth*percent[k][1];
                        let tiW = tiXEnd-tiX;
                        let tiGe = tiW/4;
                        let tiHGe = tiH/4;

                        // ctx.beginPath();ctx.rect(tiX+tiGe, iY, tiW-tiGe*2, tiH-tiHGe);ctx.stroke();
                        // console.log("", j, k, tiX, tiGe, iY, tiH, tiW, tiW-tiGe, tiH-tiHGe )

                        ctx.beginPath();
                        ctx.rect(tiX+tiGe, iY, tiW *0.65, tiH-tiHGe );
                        ctx.stroke();

                      }
                    }
                  }
                }

            }
        },
        resize(newRect) {
            // console.log("resize", newRect)
            this.pw = newRect.width;
            this.ph = newRect.height;
            this.py = newRect.top;
            this.px = newRect.left;
            this.$emit('repos', this.id, newRect);
        },
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

.point {
    border: solid 1px red;

}


</style>
